import QuickGuide from './QuickGuide';

export default QuickGuide;
